import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import API from '@/plugins/api'
import router from '@/plugins/router'
import i18n from '@/plugins/i18n'
import store from '@/plugins/store'
import { domain, clientId, audience } from "@/plugins/auth/config.json"
import { Auth0Plugin, getInstance } from "@/plugins/auth"
import FlagIcon from "vue-flag-icon";
import VueMask from 'v-mask'

import '@/styles/main.scss'
import '@/plugins/filters'

Vue.use(FlagIcon);
Vue.use(VueMask)

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl ?
        appState.targetUrl :
        window.location.pathname
    );
  }
})

//- Create a watcher to get JWT token when authenticated
const instance = getInstance();
instance.$watch("loading", async loading => {

  if (!loading) {

    if (instance.isAuthenticated) {
      const token = await instance.getTokenSilently();
      API.init(token)
        .then(() => {
          store.dispatch('app/setAuthenticated', token);
          store.dispatch('app/setUserData', instance.user);
        })
    } else {
      API.init(null);
    }
  }
});

Vue.config.productionTip = false

// Initialize what needs to be initialized and start up application
Promise.all([
])
  .then(
    new Vue({
      vuetify,
      router,
      i18n,
      store,
      render: h => h(App)
    }).$mount('#app')
  )